import PublicPage from './PublicPage';

const AboutUs = () => {
  return <PublicPage pageType="about_us" backLink="/" />;
};

export default AboutUs;
